// Menù completo Pizzeria Salviano — Livorno
export const menuSections = [
  {
    id: "classiche",
    title: "Pizze Classiche",
    items: [
      ["Marinara", "5,50"],
      ["Margherita", "6,00"],
      ["Wurstel", "7,00"],
      ["Cotto", "7,00"],
      ["Salamino Piccante", "7,50"],
      ["Napoli", "8,00"],
      ["Wurstel e Patatine", "8,00"],
      ["Funghi", "8,00"],
      ["Cotto e Mascarpone", "8,00"],
      ["Crudo", "8,00"],
      ["Vegetariana", "8,00"],
      ["Bufala", "8,00"],
      ["Salamino, Olive e Olio piccante", "8,50"],
      ["Cotto e Funghi", "8,50"],
      ["Salsiccia", "8,50"],
      ["Tonno e Cipolla", "8,50"],
      ["Salamino Nduja", "9,00"],
      ["Cotto e Philadelphia", "9,00"],
      ["Crudo e Mascarpone", "9,00"],
      ["Salsiccia e Friarelli", "9,00"],
      ["Zucchine e Grana", "9,00"],
      ["Capricciosa", "9,00"],
      ["4 Stagioni", "9,00"],
      ["4 Formaggi", "9,00"],
      ["Pesto e Bufala", "9,00"],
      ["Burrata", "9,00"],
      ["Pesto, Pomodorini e Grana", "9,00"],
      ["Speck e Mascarpone", "9,00"],
      ["Speck e Gorgonzola", "9,00"],
      ["Speck e Scamorza", "9,00"],
      ["Rucola, Pomodorini e Grana", "9,50"],
      ["Salsiccia e Salamino", "9,50"],
      ["Bresaola, Rucola e Grana", "11,00"],
      ["Crudo, Rucola e Grana", "11,00"],
    ],
  },
  {
    id: "speciali",
    title: "Pizze Speciali",
    items: [
      ["Cacio e Pepe", "8,00"],
      ["Salsiccia, Cacio e Pepe", "9,50"],
      ["Bianca, Bufala e Mortadella", "10,00"],
      ["Bufala, Pomodorini e Olive", "10,00"],
      ["Bufala, Rucola e Pomodorini", "10,00"],
      ["Salsiccia, Gorgonzola e Salamino", "10,50"],
      ["Bufala, Mortadella e Pistacchio", "11,00"],
      ["Bianca, Porcini, Lardo e Rucola", "12,00"],
      ["Salsiccia, Uova e Asparagi", "12,00"],
      ["Melanzane, Grana, Crudo e Capperi", "13,00"],
      ["Gorgonzola, Noci e Asparagi", "13,00"],
      ["Salsiccia, Broccoli e Zucca", "13,00"],
      ["Bianca, Pesto, Salsiccia, Patatine, Gorgonzola e Zucchine (Romolo)", "13,00"],
      ["Bianca, Salsiccia, Grana, Burrata e Olio Tartufato", "13,00"],
      ["Bianca, Pesto, Salsiccia, Pecorino e Porcini", "14,00"],
      ["Bufala, Salsiccia, Noci, Grana e Patatine (Salviano)", "14,00"],
      ["Wurstel, Funghi, Cotto, Peperoni e Salamino", "14,00"],
    ],
  },
  {
    id: "stracciatella",
    title: "Pizze con Stracciatella",
    items: [
      ["Bianca, Stracciatella e Mortadella", "9,00"],
      ["Stracciatella, Pomodorini e Rucola", "10,50"],
      ["Stracciatella, Funghi e Speck", "11,00"],
      ["Stracciatella, Cotto e Bufala", "12,00"],
      ["Bianca, Stracciatella, Mortadella e Granella di Pistacchio", "12,00"],
    ],
  },
  {
    id: "baby",
    title: "Pizze Baby",
    items: [
      ["Baby Rossa", "4,50"],
      ["Baby Margherita", "5,00"],
      ["Baby Funghi", "6,00"],
      ["Baby Salamino", "6,00"],
      ["Baby Wurstel", "6,00"],
      ["Baby Cotto e Mascarpone", "6,00"],
      ["Baby Patatine", "6,00"],
      ["Baby Patatine e Wurstel", "6,50"],
      ["Baby Bufala", "7,00"],
      ["Baby Patatine e Salsiccia", "7,00"],
      ["Baby Speck e Mascarpone", "7,00"],
      ["Baby Crudo e Mascarpone", "7,00"],
    ],
  },
  {
    id: "focacce",
    title: "5 e 5 · Schiacciatine · Focacce",
    items: [
      ["Torta di Ceci 100g", "1,80"],
      ["5 e 5", "2,50"],
      ["5 e 5 con Melanzane", "3,00"],
      ["Schiacciatina vuota", "0,80"],
      ["Schiacciatina Cotto e Mozzarella", "3,00"],
      ["Schiacciatina Crudo e Mozzarella", "4,00"],
      ["Schiacciatina Bresaola, Rucola e Grana", "5,00"],
      ["Schiacciatina Crudo, Rucola e Grana", "5,00"],
      ["Focaccia Vuota", "2,00"],
      ["Focaccia Vegetariana", "6,00"],
      ["Focaccia con Cotto e Mozzarella", "7,00"],
      ["Focaccia con Crudo e Mozzarella", "9,00"],
      ["Focaccia con Bresaola, Rucola e Grana", "9,00"],
    ],
  },
  {
    id: "calzoni",
    title: "Calzoni",
    items: [
      ["Calzone con Prosciutto Cotto e Mozzarella", "8,00"],
      ["Calzone con Prosciutto Cotto, Mozzarella e Philadelphia", "9,00"],
      ["Calzone con Salamino e Mozzarella", "9,00"],
    ],
  },
  {
    id: "fritture",
    title: "Fritture",
    items: [
      ["Patate Piccole", "3,00"],
      ["Patate Grandi", "5,00"],
      ["Pane Fritto", "3,50"],
      ["Panzerotto", "3,50"],
      ["Anelli di Cipolla", "4,00"],
      ["Mozzarelline", "4,00"],
      ["Verdure Pastellate", "4,00"],
      ["Olive all'Ascolana", "4,00"],
      ["Crocchette di Patate", "4,00"],
      ["Crocchette di Pollo", "4,00"],
    ],
  },
  {
    id: "dolci",
    title: "Dolci",
    items: [
      ["Schiacciatina Piccola con Nutella Ø 14cm", "3,00"],
      ["Schiacciatina Grande con Nutella Ø 26cm", "7,00"],
      ["Coppa Tiramisù", "4,00"],
      ["Profiterols Cacao", "4,00"],
      ["Cheesecake", "4,00"],
      ["Tartufo Bianco", "4,00"],
      ["Tartufo Nero", "4,00"],
      ["Pizza Baby con Nutella", "5,50"],
      ["Pane Fritto con Nutella", "6,00"],
      ["Pizza con Nutella", "7,00"],
      ["Calzone Piccolo con Nutella e Mascarpone", "4,50"],
      ["Calzone con Nutella e Mascarpone", "7,50"],
    ],
  },
  {
    id: "bevande",
    title: "Bevande",
    items: [
      ["Acqua Naturale 50cl", "1,00"],
      ["Acqua Frizzante 50cl", "1,00"],
      ["Acqua Naturale 1L", "1,50"],
      ["Acqua Frizzante 1L", "1,50"],
      ["Coca Cola 33cl", "2,50"],
      ["Coca Cola Zero 33cl", "2,50"],
      ["Fanta 33cl", "2,50"],
      ["Sprite 33cl", "2,50"],
      ["Estathé Pesca 33cl", "2,50"],
      ["Estathé Limone 33cl", "2,50"],
      ["Spuma Bionda 1,5L", "3,00"],
      ["Fanta 1,5L", "4,00"],
      ["Estathé al Limone 1,5L", "4,00"],
      ["Coca Cola 1,5L", "4,00"],
      ["Coca Cola Zero 1,5L", "4,00"],
      ["Birra Moretti 33cl", "2,50"],
      ["Birra Ichnusa 33cl", "3,00"],
      ["Birra Ichnusa non Filtrata 33cl", "3,50"],
      ["Birra Tennent's 33cl", "3,50"],
      ["Birra Moretti 66cl", "4,00"],
      ["Birra Ichnusa 66cl", "4,50"],
      ["Vino Bianco 1L", "7,00"],
      ["Vino Rosso 1L", "7,00"],
    ],
  },
];

export const menuExtra = "Pizza con impasto integrale e ai 7 cereali: +1,00 € sul prezzo di listino";
